/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const FlashlightOff = [
  ["path", { d: "M11.652 6H18" }],
  ["path", { d: "M12 13v1" }],
  [
    "path",
    { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8a4 4 0 0 0-.8-2.4l-.6-.8A3 3 0 0 1 6 7V6" }
  ],
  ["path", { d: "m2 2 20 20" }],
  ["path", { d: "M7.649 2H17a1 1 0 0 1 1 1v4a3 3 0 0 1-.6 1.8l-.6.8a4 4 0 0 0-.55 1.007" }]
];

export { FlashlightOff as default };
//# sourceMappingURL=flashlight-off.js.map
